import '@vimeo/player/dist/player.js';
import '../components/hs-video-player';

export default {

  init() {
    // JavaScript to be fired on the single online course page



    },
  finalize() {
    // JavaScript to be fired on the single online course page

    // initialization of vimeo video player
    $.HSCore.components.HSVideoPlayer.init('.js-inline-video-player');

    //BIZ 1418 START: sidebar change to down arrow on click
    $(".learning-info-tab").on("click", function(){
      $(".learning-info-tab").find(".fas").addClass('fa-arrow-right').removeClass('fa-arrow-down');
      if($(this).find("button").hasClass("collapsed")){
        $(this).find(".small").addClass("fa-arrow-down").removeClass("fa-arrow-right");
      }
    })
    //BIZ 1418 END: sidebar change to down arrow on click
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/single-online-course.js